<div [ngClass]="{'whiteColor': currentRoute == 'login','grayColor': currentRoute != 'login'}" class="text-center">
  Site designed, hosted by National Informatics Center
  <br/>
  <span *ngIf="state != 'Delhi'">
    © Content Owned, Updated and Maintained by {{state}} State Pollution Control Board
  </span>

  <span *ngIf="state == 'Delhi'">
    © Content Owned, Updated and Maintained by {{state}} Pollution Control Committee
  </span>
</div>
